module.exports = __webpack_public_path__ + "static/media/Deutsche_Terms_And_Conditions.f2f39104.pdf";